import { getTranslatedPhysioPostGradOption } from "../lists/qualification";
import { formatYesNoDropdownLists } from "../utils/form-data-utils";

export const formatQualificationPhysioPostGradDataFormValues = (associate, language = "pt") => { 
    associate.qualificationData.hasPhysioPostGrads = formatYesNoDropdownLists(associate.physiotherapyPostGrads.length > 0, language);

    for (let i = 0; i < associate.physiotherapyPostGrads.length; i++) {
        associate.physiotherapyPostGrads[i].acceptanceDate = associate.physiotherapyPostGrads[i].acceptanceDate !== null ? new Date(associate.physiotherapyPostGrads[i].acceptanceDate) : null;
        associate.physiotherapyPostGrads[i].endDate = associate.physiotherapyPostGrads[i].endDate !== null ? new Date(associate.physiotherapyPostGrads[i].endDate) : null;
        
        if(typeof associate.physiotherapyPostGrads[i].degreeLevel  !== 'object' && associate.physiotherapyPostGrads[i].degreeLevel !== null) {
            associate.physiotherapyPostGrads[i].degreeLevel = { name: associate.physiotherapyPostGrads[i].degreeLevel, code: associate.physiotherapyPostGrads[i].degreeLevel };
        }
        else if (typeof associate.physiotherapyPostGrads[i].degreeLevel === 'object' && associate.physiotherapyPostGrads[i].degreeLevel !== null) {
            associate.physiotherapyPostGrads[i].degreeLevel = getTranslatedPhysioPostGradOption(associate.physiotherapyPostGrads[i].degreeLevel.code, language);
        }

        if(typeof associate.physiotherapyPostGrads[i].trainingCountry  !== 'object' && associate.physiotherapyPostGrads[i].trainingCountry !== null) {
            associate.physiotherapyPostGrads[i].trainingCountry = { name: associate.physiotherapyPostGrads[i].trainingCountry, code: associate.physiotherapyPostGrads[i].trainingCountry };
        }    
    }

    return associate;
}

export const formatQualificationPhysioPostGradDataToService = (associate) => { 
    for (let i = 0; i < associate.physiotherapyPostGrads.length; i++) {
        associate.physiotherapyPostGrads[i].degreeLevel = associate.physiotherapyPostGrads[i].degreeLevel.code;
        associate.physiotherapyPostGrads[i].trainingCountry = associate.physiotherapyPostGrads[i].trainingCountry.code;
    }

    return associate;
}